export enum ECisalikvynos {
    _1 = '1',
    _2 = '2',
    _3 = '3',
    _9 = '9',
    _4 = '4',
    _10 = '10',
    _13 = '13',
    _8 = '8',
    _7 = '7',
    _5 = '5',
    _11 = '11',
    _6 = '6',
    _12 = '12'
}
